module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Заявитель",
      "required": true,
      "name": "applicant_who",
      "id": "applicant_who",
      "error": _vm.errors.first('applicant_who'),
      "data-vv-name": "applicant_who",
      "data-vv-as": ' ',
      "disabled": _vm.$props.block,
      "inline": "inline",
      "dirty": _vm.dirtyObj.type
    },
    on: {
      "update:dirty": function($event) {
        _vm.$set(_vm.dirtyObj, "type", $event)
      }
    },
    model: {
      value: (_vm.who),
      callback: function($$v) {
        _vm.who = $$v
      },
      expression: "who"
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.$props.deal.sender_id
    }
  }, [_vm._v("Отправитель")]), _c('option', {
    domProps: {
      "value": _vm.$props.deal.recipient_id
    }
  }, [_vm._v("Получатель")]), (parseInt(_vm.$props.deal.payer_id) !== parseInt(_vm.$props.deal.sender_id) && parseInt(_vm.$props.deal.payer_id) !== parseInt(_vm.$props.deal.recipient_id)) ? _c('option', {
    domProps: {
      "value": _vm.$props.deal.payer_id
    }
  }, [_vm._v("Плательщик")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7442ce41","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Applicant.vue
// module id = 1193
// module chunks = 0